module.exports = __webpack_public_path__ + "static/media/hengshanicon.15ff93f7.webp";